import ConditionalVisuallyHidden from './conditionalVisuallyHidden';

export { type ConditionalVisuallyHiddenProps } from './conditionalVisuallyHidden';

export default ConditionalVisuallyHidden;
